import { globalActions } from '../../global-actions';

export const getActionTypes = (actionPrefix) => ({
  // START
  FETCH_START: `${actionPrefix}_FETCH_START`,
  UPDATE_START: `${actionPrefix}_UPDATE_START`,
  // SUCCESS
  FETCH_SUCCESS: `${actionPrefix}_FETCH_SUCCESS`,
  UPDATE_SUCCESS: `${actionPrefix}_UPDATE_SUCCESS`,
  // FAILURE
  FETCH_FAILURE: `${actionPrefix}_FETCH_FAILURE`,
  UPDATE_FAILURE: `${actionPrefix}_UPDATE_FAILURE`,
  // USER INTERACTION
  SELECT_OPTIONS: `${actionPrefix}_SELECT_OPTIONS`,
});

export const getActions = (actionPrefix) => ({
  setFetchStart: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).FETCH_START,
    });
  },
  setUpdateStart: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).UPDATE_START,
    });
  },
  setFetchSuccess: (data) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).FETCH_SUCCESS,
      payload: { data },
    });
  },
  setUpdateSuccess: (data) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).UPDATE_SUCCESS,
      payload: { data },
    });
  },
  setFetchFailure: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).FETCH_FAILURE,
      payload: { error },
    });
  },
  setUpdateFailure: (error) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).UPDATE_FAILURE,
      payload: { error },
    });
  },
  selectNewsletters: (options) => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SELECT_OPTIONS,
      payload: { options },
    });
  },
});
